<template>
  <span>
    <i class="fas fa-check status-active" v-if="value"></i>
    <i class="fas fa-times status-inactive" v-if="!value && displayFalse"></i>
    <span v-if="!value && !displayFalse">-</span>
  </span>
</template>

<script>
export default {
  name: 'IconBoolean',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    displayFalse: {
      type: Boolean,
      default: true
    }
  }
}
</script>
